import { inject, Injectable } from '@angular/core';

import { Visibility, VisibilityLevel } from '@core/visibility-types';

import { AutomationsAccessoryDataService } from './automations-accessory-data.service';

@Injectable()
export class ActionVisibilityHelpers {
  private readonly accessoryDataService = inject(AutomationsAccessoryDataService);

  public isActionVisible(visibility: Visibility) {
    const { level, adminIds = [], roleIds = [] } = visibility;
    return (
      level === VisibilityLevel.Public ||
      adminIds.includes(this.accessoryDataService.currentUser()!.id) ||
      roleIds.includes(this.accessoryDataService.currentUser()!.roleId)
    );
  }
}
